// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import "./chatStyle.scss";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'message' implicitly has an 'any' type.
function SentHomeResponseMessage({ message }) {
  return (
    <div className="fcm-message-container">
      <div className="avatar-container">
        <div className="avatar-wrapper">
          <img src={`${process.env.REACT_APP_BASE_PATH || "/"}bunnyVerticalAgnostic.png`} alt="" />
        </div>
      </div>
      <div className="message-container">
        <span>Clipboard</span>
        <div className="message-wrapper">
          <div>
            <p>{message.message}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export { SentHomeResponseMessage };
